module.exports = __webpack_public_path__ + "static/blue-bg1-3e6e195cf7b5763a60e7a01df90e3733.jpg";